var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAandG(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129.86 129.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16261",
    d: "m64.93,129.86c35.86,0,64.93-29.07,64.93-64.93C129.86,29.07,100.79,0,64.93,0S0,29.07,0,64.93h0c0,35.86,29.07,64.93,64.93,64.93m0-122.99c32.07,0,58.07,26,58.07,58.07s-26,58.06-58.07,58.06S6.86,97,6.86,64.93c0-32.07,26-58.06,58.07-58.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16262",
    d: "m64.93,18.11c-25.85,0-46.81,20.96-46.82,46.81,0,25.85,20.96,46.81,46.81,46.82,25.85,0,46.81-20.96,46.82-46.81h0c-.03-25.84-20.97-46.78-46.81-46.82m-3.82,24.54c.03-2.11,1.77-3.79,3.88-3.76,2.06.03,3.72,1.7,3.76,3.76v31.83c-.03,2.11-1.77,3.79-3.88,3.76-2.06-.03-3.72-1.7-3.76-3.76v-31.83Zm3.82,48.37c-2.55,0-4.62-2.06-4.62-4.61,0-2.55,2.06-4.62,4.61-4.62,2.55,0,4.62,2.06,4.62,4.61h0c0,2.55-2.06,4.61-4.61,4.62"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAandG);
export default __webpack_public_path__ + "static/media/AandG.5117ac26d2e1df74cdf65cb315609b80.svg";
export { ForwardRef as ReactComponent };